<template>
  <a-drawer
    width="900"
    :label-col="4"
    :wrapper-col="14"
    :visible="open"
    @close="onClose"
    :destroyOnClose="true">
    <a-divider orientation="left">
      <b>详情</b>
    </a-divider>
    <a-descriptions bordered :column="2" size="middle">
      <a-descriptions-item label="订单号">{{ form.orderNo }}</a-descriptions-item>
      <a-descriptions-item label="三方流水号">{{ form.orderPayNo }}</a-descriptions-item>

      <a-descriptions-item label="用户名称">{{ form.userIdName }}</a-descriptions-item>
      <a-descriptions-item label="用户手机号">{{ form.czUserPhone }}</a-descriptions-item>
      <a-descriptions-item label="绑定人名称">{{ form.userName }}</a-descriptions-item>
      <a-descriptions-item label="绑定人手机号">{{ form.userPhone }}</a-descriptions-item>

      <a-descriptions-item label="设备类型">{{ form.typeName }}</a-descriptions-item>
      <a-descriptions-item label="设备名称">{{ form.devName }}</a-descriptions-item>
      <a-descriptions-item label="设备编号">{{ form.devCode }}</a-descriptions-item>
      <a-descriptions-item label="水表编号">{{ form.devSn }}</a-descriptions-item>

      <!-- <a-descriptions-item label="订单优惠金额">{{ form.orderDiscountMoney }}</a-descriptions-item> -->
      <a-descriptions-item label="订单总金额">{{ form.orderMoney }}</a-descriptions-item>

      <a-descriptions-item label="支付类型">
        <a-tag color="green" v-if="form.payType == 0">微信</a-tag>
        <a-tag color="blue" v-else-if="form.payType == 1">平台</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="支付状态">
        <a-tag color="orange" v-if="form.orderPayState == 0">待支付</a-tag>
        <a-tag color="green" v-else-if="form.orderPayState == 1">已支付</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="订单状态">
        <a-tag color="orange" v-if="form.orderStatus == 0">待支付</a-tag>
        <a-tag color="green" v-if="form.orderStatus == 1">充值成功</a-tag>
        <a-tag color="blue" v-else-if="form.orderStatus == 2">订单取消</a-tag>
        <a-tag color="red" v-else-if="form.orderStatus == 3">已退款</a-tag>
        <a-tag color="cyan" v-else-if="form.orderStatus == 4">申请退款中</a-tag>
      </a-descriptions-item>
      <a-descriptions-item label="订单下单时间">{{ form.orderTime }}</a-descriptions-item>
      <a-descriptions-item label="订单付款时间">{{ form.payTime }}</a-descriptions-item>
      <a-descriptions-item label="订单完成时间">{{ form.completeTime }}</a-descriptions-item>
      <a-descriptions-item label="订单取消时间">{{ form.cancelTime }}</a-descriptions-item>
      <a-descriptions-item label="订单未付款结束时间">{{ form.endTime }}</a-descriptions-item>
      <a-descriptions-item label="订单结束时间">{{ form.expireTime }}</a-descriptions-item>

      <a-descriptions-item label="添加时间">{{ form.createTime }}</a-descriptions-item>
      <a-descriptions-item label="备注">{{ form.remark }}</a-descriptions-item>
    </a-descriptions>
  </a-drawer>
</template>

<script>

import { orderInfo } from '@/api/pages/payment-refund'

export default {
  name: 'CreateForm',
  props: {
  },
  data () {
    return {
      submitLoading: false,
      form: {},
      open: false
    }
  },
  filters: {
  },
  created () {
  },
  computed: {
  },
  watch: {
  },
  methods: {
    onClose () {
      this.open = false
    },
    info (id) {
      orderInfo({ id }).then(response => {
        this.form = response.data
        this.open = true
      })
    }
  }
}
</script>
<style lang="less" scoped>
  .ant-upload-preview {
    position: relative;
    width: 100px;
    height: 100px;
    .upload-icon {
      position: absolute;
      top: 0;
      right: 10px;
      font-size: 1.4rem;
      padding: 0.5rem;
      background: rgba(222, 221, 221, 0.7);
      border: 1px solid rgba(0, 0, 0, 0.2);
    }
    .mask {
      position: absolute;
      background: rgba(0,0,0,0.4);
      cursor: pointer;
      transition: opacity 0.4s;
      &:hover {
        opacity: 1;
      }
      i {
        font-size: 2rem;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -1rem;
        margin-top: -1rem;
        color: #d6d6d6;
      }
    }
    img, .mask {
      width: 100%;
      max-width: 180px;
      height: 100%;
      overflow: hidden;
      object-fit: contain;
    }
  }
</style>
